// extracted by mini-css-extract-plugin
export var tosLink = "_79-0";